<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container class="white" v-if="!selectedProject">
        <v-layout row wrap>
          <v-flex xs12 class="white--text primary">
            <v-card-title><h3 class="headline mb-0">Select a project to create a task:</h3></v-card-title>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs8>
            <v-autocomplete v-model="preProjectSelection" @change="loadProjectAndTasks" :items="projectsList" :rules="validationRequired" label="Select a Project" required prepend-icon="list"></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-btn @click="closeForm" class="secondary">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container class="white" v-if="selectedProject">
        <v-layout row wrap>
          <v-flex xs12 class="white--text primary">
            <v-card-title><h3 class="headline mb-0">Create New Task for {{selectedProject.name}}</h3></v-card-title>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-text-field style="max-width: 400px" v-model="newTask.name" :rules="nameRules" :counter="30" label="Task Name" required prepend-icon="list"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-layout row>
              <v-select clearable v-model="newTask.phase" :items="projectPhasesDropDown" label="Phase" prepend-icon="file_copy"></v-select>
              <v-btn flat icon @click="editPhaseDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-select v-model="newTask.execution" :items="execution" :rules="validationRequired" label="Task Starts" required prepend-icon="insert_invitation"></v-select>
          </v-flex>
          <v-flex xs6 md5 v-if="newTask.execution === 'From Task Completion'">
            <v-select v-model="newTask.after_task" :items="tasksDropDown" :rules="validationRequired" label="After This Task Completes:" required prepend-icon=" "></v-select>
          </v-flex>
          <v-flex xs5 md5>
            <v-text-field v-model="newTask.days_due" :rules="validationRequired" :label="newTask.after_task ? 'Days Due From Task Completion' : 'Days until Due From Start Date'" required prepend-icon="today"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-layout row>
              <v-select clearable v-model="newTask.required_upload" :items="filesDropDown" label="Required File Upload" prepend-icon="file_copy"></v-select>
              <v-btn flat icon @click="editFileDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs3 md3 justify-end>
            <v-checkbox v-model="newTask.if_na" label="Allow N/A?" prepend-icon=" "></v-checkbox>
          </v-flex>
          <v-flex xs3 md3 justify-end>
            <v-checkbox v-model="newTask.showTaskOnReport" label="Show On Report Summary"></v-checkbox>
          </v-flex>
          <v-flex xs12>
            <v-btn @click="showAddChecklist = true"><v-icon left>check</v-icon>Add Check Lists</v-btn>
          </v-flex>
          </v-layout>
          <v-layout v-if="showAddChecklist" row wrap>
            <v-flex xs6>
              <v-text-field v-model="checkListItem" label="Add Checklist Item" prepend-icon="check"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-btn @click="addCheckListItems">Add Item</v-btn>
            </v-flex>
            <v-flex xs6 v-if="addedChecklistItems.length > 0">
              <v-toolbar height="40px" dark color="secondary">
                <v-toolbar-title class="subheading">Added Checklist Items</v-toolbar-title><span class="ml-3 caption">(Drag to Reorder)</span>
              </v-toolbar>
              <v-list>
                <draggable v-model="addedChecklistItems" style="min-height: 10px">
                  <v-list-tile v-for="(item, index) in addedChecklistItems" :key="index">
                    <v-list-tile-action>
                      <v-btn icon><v-icon>reorder</v-icon></v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="item"></v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-icon @click="deleteChecklistItem(index)">delete</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </draggable>
              </v-list>
            </v-flex>
          </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-btn :disabled="!valid" flat class="primary" @click="saveTask"><v-icon left>edit</v-icon>Save and Close</v-btn>
            <v-btn flat class="secondary" @click="closeForm">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <!-- Edit File Drop Down -->
    <v-dialog max-width="600px" v-model="editFileDropdownDialog">
      <edit-dropdown v-if="editFileDropdownDialog" dropdownName="files" @closeDialog="editFileDropdownDialog = false"/>
    </v-dialog>
    <!-- Edit Project Phase Drop Down -->
    <v-dialog max-width="600px" v-model="editPhaseDropdownDialog">
      <edit-dropdown v-if="editPhaseDropdownDialog" dropdownName="projectPhases" @closeDialog="editPhaseDropdownDialog = false"/>
    </v-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import EditDropdown from '../../helpers/EditDropdown'
import _ from 'lodash'
export default {
  props: ['project', 'tasks'],
  data () {
    return {
      preProjectSelection: null,
      gatheredProjectTasks: null,
      editFileDropdownDialog: false,
      editPhaseDropdownDialog: false,
      showDueDateDialog: false,
      valid: true,
      checkListItem: null,
      showAddChecklist: false,
      addedChecklistItems: [],
      taskList: [],
      newTask: {order: null, name: null, phase: null, execution: null, due_date: null, after_task: null, if_required: false, if_na: false, required_upload: null, deleted: false},
      // execution: ['From Start Date', 'From Task Completion'],
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      validationRequired: [
        v => !!v || 'Field is required'
      ]
    }
  },
  computed: {
    selectedProjectTasks () {
      if (this.tasks) {
        return this.tasks
      } else {
        return this.gatheredProjectTasks
      }
    },
    selectedProject () {
      if (this.project) {
        return this.project
      } else {
        const getProject = this.$store.getters.getProject
        let projectTasks = []
        if (getProject && getProject.tasks) {
          const taskKeys = Object.keys(getProject.tasks)
          taskKeys.forEach(key => {
            projectTasks.push({ id: key, ...getProject.tasks[key] })
          })
          this.gatheredProjectTasks = projectTasks
        }
        return getProject
      }
    },
    projectsList () {
      const allProjects = this.$store.getters.projectSearch
      return allProjects.map(m => ({ text: m.name, value: m.id }))
    },
    filesDropDown () {
      let getFileDropDown = this.$store.getters.files
      // getFileDropDown.push('Pool Print', 'Jobsite Photos')
      return getFileDropDown.sort()
    },
    execution () {
      return this.selectedProjectTasks.length > 0 ? ['From Start Date', 'From Task Completion'] : ['From Start Date']
    },
    tasksDropDown () {
      // let taskList = this.$store.getters.getTemplateTasks
      let taskList = this.selectedProjectTasks
      let items = []
      let taskOrder = _.orderBy(taskList, ['order', 'name'])
      // taskList.filter(f => f.taskTemplateId === this.selectedTemplate.id)
      taskOrder.forEach(item => {
        if (item.deleted !== true) {
          items.push({ text: item.name, value: item.id })
        }
      })
      return items
    },
    projectPhasesDropDown () {
      let getPhasesDropDown = this.$store.getters.projectPhases
      // getPhasesDropDown.push('Pool Print', 'Jobsite Photos')
      return getPhasesDropDown.sort()
    }
  },
  methods: {
    loadProjectAndTasks () { // If creating a task from outside a project, get the project then assign the values
      this.$store.dispatch('getProject', this.preProjectSelection)
    },
    saveTask () {
      if (this.$refs.form.validate()) {
        let task = this.newTask
        this.newTask.days_due = Number(this.newTask.days_due)
        delete task.after_task_name
        delete task.task_starts
        delete task.order
        const projectStartDate = new Date(this.selectedProject.start_date.seconds * 1000)
        const taskDueDate = new Date(this.selectedProject.start_date.seconds * 1000)
        const tasklist = []
        if (task.after_task && task.execution !== 'From Start Date') {
          const afterTask = this.selectedProjectTasks.filter(f => f.id === task.after_task)[0]
          const afterTaskDueDate = new Date(afterTask.due_date.seconds * 1000)
          task.start_date = afterTaskDueDate
          taskDueDate.setDate(afterTaskDueDate.getDate() + parseInt(task.days_due))
          task.after_task = afterTask.id
        } else {
          task.start_date = projectStartDate
          taskDueDate.setDate(projectStartDate.getDate() + parseInt(task.days_due))
        }
        this.addedChecklistItems.forEach(item => {
          const obj = { name: item, created_date: new Date(), active: true, completed: null, completed_by: null, completed_date: null }
          tasklist.push(obj)
        })
        task = {...task, checklist: tasklist, due_date: taskDueDate}
        const payload = {newTask: task, project: this.selectedProject}
        this.$store.dispatch('newProjectTask', payload)
        this.closeForm()
      }
    },
    clearForm () {
      Object.keys(this.newTask).forEach((key, index) => {
        this.newTask[key] = null
        this.newTask.deleted = false
        this.newTask.if_na = false
        this.newTask.if_required = false
      })
    },
    closeForm () {
      this.$emit('closeDialog')
      this.checkListItem = null
      this.showAddChecklist = false
      this.addedChecklistItems = []
    },
    deleteChecklistItem (index) {
      this.addedChecklistItems.splice(index, 1)
    },
    addCheckListItems () {
      this.addedChecklistItems.push(this.checkListItem)
      this.checkListItem = null
    }
  },
  components: {
    draggable,
    EditDropdown
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tasks/CreateTask.vue